import { gql } from '@apollo/client';

export default gql`
  query AllProductFeaturesQuery(
    $orderBy: [ProductFeaturesOrderBy!]
    $condition: ProductFeatureCondition!
    $filter: ProductFeatureFilter
  ) {
    productFeatures: allProductFeatures(
      orderBy: $orderBy
      condition: $condition
      filter: $filter
    ) {
      nodes {
        id
        name
      }
    }
  }
`;
